<!-- <p-card class="pt-0"> -->
<p-card>
  <div class="grid">

    <div class="col-12 md:col-12 lg:col-12 breadcrumbrightmenu">
      <div class="p-0 border-round-sm font-bold ">
        <!-- First add condition -->
        <p-button
          *ngIf="conditionValidator == 'noAccessRestrictions' && ((numberOfUsers > currentNumberOfusers) && userRole == 1  )"
          (click)="show('Add User','')" styleClass="customAdd p-button-sm p-button-raised mr-1"
          icon="fa fa-plus" pTooltip="Add User" tooltipPosition="left"></p-button>


        <p-button *ngIf="conditionValidator == 'noAccessRestrictions' && emergencyValidator == 'lockAllExceptAdmin'"
          (click)="show('Emergency Stop','')" style="cursor:pointer;color:green;font-size: 40px"
          pTooltip="Lock All Users Except Admin" tooltipPosition="left" icon="fa fa-unlock" styleClass="p-button-sm p-button-raised mr-1"></p-button>
        <!-- Unlock all users -->
        <p-button *ngIf="conditionValidator == 'noAccessRestrictions' && emergencyValidator == 'unlockAll'"
          (click)="show('Emergency Start','')" style="cursor:pointer;color:red;font-size: 40px"
          pTooltip="Unlock all users" tooltipPosition="left" icon="fa fa-lock" styleClass="p-button-sm p-button-raised mr-1"></p-button>
        <!-- 2nd add condition -->
        <p-button *ngIf="conditionValidator == 'adminBusinessUserRequired' " (click)="show('Add User','')"
          styleClass="customAdd p-button-sm p-button-raised mr-1" pTooltip="Add User" tooltipPosition="left" icon="fa fa-plus"></p-button>
        <!-- Lock all users except admin -->
        <p-button
          *ngIf="conditionValidator == 'adminBusinessUserRequired' && emergencyValidator == 'lockAllExceptAdmin'"
          (click)="show('Emergency Stop','')" style="cursor:pointer;color:green;font-size: 40px"
          pTooltip="Lock All Users Except Admin" tooltipPosition="left"  icon="fa fa-unlock" styleClass="p-button-sm p-button-raised mr-1"></p-button>
        <!-- Unlock all users -->
        <p-button *ngIf="conditionValidator == 'adminBusinessUserRequired' && emergencyValidator == 'unlockAll'"
          (click)="show('Emergency Start','')" style="cursor:pointer;color:red;font-size: 40px"
          pTooltip="Unlock all users" tooltipPosition="left"  icon="fa fa-lock"styleClass="p-button-sm p-button-raised mr-1"></p-button>


        <p-button *ngIf="excelUploadValidator == 'Allow' " class="btn btn-primary-outline btn-sm hidcls"
          pTooltip="Download Excel template" id="complexcelformat" (click)="downloadformate=true" styleClass="p-button-sm p-button-raised mr-1" tooltipPosition="left" >Download Excel
          Format</p-button>

        <p-button *ngIf="excelUploadValidator == 'Allow' " class="btn btn-primary-outline btn-sm hidcls"
          pTooltip="Upload User Data" tooltipPosition="left" id="complexcelformat" (click)="openexceluploadmodal()"styleClass="p-button-sm p-button-raised mr-1">Upload Users</p-button>
        <!-- <a class="fa fa-question-circle help-icon mr-1" pTooltip="Help"
          (click)="PagehelpmodalService.openhelpmodal(ref,dialogService,'Help','8')" tooltipPosition="bottom"
          aria-hidden="true"></a> -->
                  <button type="button" class="fa fa-question helpicon"(click)="PagehelpmodalService.openhelpmodal(ref,dialogService,'Help','8')" pTooltip="Help" tooltipPosition="bottom"></button>

      </div>
    </div>

  </div>

  <div *ngIf="userRole == 0" class="formgrid grid">
    <div class="field col-12"
      style="display: flex; justify-content: center; align-items: center; gap: 10px; text-align: center;">
      <label for="group" style="font-weight: bold;">Organisation</label>
      <p-dropdown [options]="organisationList" [filter]="true" appendTo="body" optionLabel="name" optionValue="orgid"
        formControlName="group" id="group" [(ngModel)]="filterinput.torganisation"
        (onChange)="onOrgChange($event.value)" name="group" style="width: 40%; min-width: 250px;" [showClear]="true">
      </p-dropdown>
    </div>
  </div>


  <p-tabView>
    <p-card style="margin: 0px;">
      <div class="grid">
        <div class="col-12 md:col-3 lg:col-3 sm:col-6">
          <label class="filter" for="processid">Product</label>
          <p-dropdown [filter]="true" [options]="productlist" placeholder="Select" [(ngModel)]="filterinput.tproduct"
            optionLabel="productname" optionValue="productid" styleClass="fixed-width-dropdown-filter"
            [pTooltip]="getSelectedProduct()" (onChange)="getParams2()"[resetFilterOnHide]="true" [showClear]="true"></p-dropdown>
        </div>

        <div class="col-12 md:col-3 lg:col-3 sm:col-6">
          <label class="filter" for="entityid">Entity </label>
          <p-dropdown [options]="entitylist" optionLabel="companyname" optionValue="companyid"
            styleClass="fixed-width-dropdown-filter" (onChange)="getParams2()" placeholder="Select" [filter]="true"
            [(ngModel)]="filterinput.tentity" [pTooltip]="getSelectedEntity()" [resetFilterOnHide]="true" [showClear]="true">
          </p-dropdown>
        </div>

        <div class="col-12 md:col-3 lg:col-3 sm:col-6">
          <label class="filter"for="location">Location</label>
          <p-dropdown [filter]="true" [(ngModel)]="filterinput.tlocation" [options]="locationList" placeholder="Select"
            optionLabel="locationname" optionValue="locationid" styleClass="fixed-width-dropdown-filter"
            (onChange)="getParams2()" inputId="location" [pTooltip]="getSelectedLocation()"[resetFilterOnHide]="true" [showClear]="true"></p-dropdown>
        </div>
        <div class="col-12 md:col-3 lg:col-3 sm:col-6">
          <label class="filter"for="dep">Department</label>
          <p-dropdown [filter]="true" [(ngModel)]="filterinput.tdepartment" [options]="departList" placeholder="Select"
            optionLabel="departmentname" [pTooltip]="getSelectedDepartment()"  tooltipPosition="bottom" optionValue="departmentid"
            styleClass="fixed-width-dropdown-filter" (onChange)="getParams2()" inputId="dep"[resetFilterOnHide]="true" [showClear]="true"></p-dropdown>
        </div>

      </div>
      <div class="grid">
        <div *ngIf="configparams?.requirevertlabel==='Y'" class="col-12 md:col-3 lg:col-3 sm:col-6">
          <label class="filter" for="location">{{configparams?.vertlabelname}}</label>
          <p-dropdown [filter]="true" [pTooltip]="getSelectedVertical()"  [options]="verticalList"
            [(ngModel)]="filterinput.tvertical" placeholder="Select" title="Select Vertical" optionLabel="name"
            optionValue="verticalid" styleClass="fixed-width-dropdown-filter" (onChange)="getParams2()"
            inputId="location"[resetFilterOnHide]="true" [showClear]="true"></p-dropdown>

        </div>
        <div class="col-12 md:col-3 lg:col-3 sm:col-6">
          <label class="filter" for="dep">Status</label>
          <p-dropdown [filter]="true" [pTooltip]="getSelectedStatus()" [options]="activestatus" [(ngModel)]="filterinput.tstatus"
            placeholder="Select" optionLabel="labelname" optionValue="activeflag"
            styleClass="fixed-width-dropdown-filter" (onChange)="getParams2()" inputId="dep"[resetFilterOnHide]="true" [showClear]="true"></p-dropdown>

        </div>
        <div class="filterbutton">
           <i class="fa fa-refresh refreshbutton" aria-hidden="true" (click)="refreshFilters()" pTooltip="Reset" tooltipPosition="bottom" ></i>

          <!-- <p-button styleClass="refreshbtn" severity="success" (click)="refreshFilters()">
            <i class="fa fa-refresh" aria-hidden="true"></i>
          </p-button> -->
        </div>
      </div>
    </p-card>


    <!-- </p-card> -->
    <!-- <div class="card" style="margin: 0px;"> -->
    <div class="mr-0 tablehiegt" *ngIf="userslistarray.length>0">

      <p-table #dt [value]="userslistarray" [customSort]="true" (sortFunction)="this.utilityservice.customSort($event)"
        [rows]="rows2" [scrollable]="true" scrollDirection="horizontal" scrollHeight="{{commonScrollHeight}}"
        [globalFilterFields]="['userid','username','departmentname','email','createdon','activeflag','rolename','locationname','createdby']"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [rowsPerPageOptions]="paginatorArray" [paginator]="totalRecords>0" dataKey="id" [rowHover]="true"
        [showCurrentPageReport]="true" paginatorLocale="fa-IR" (onPage)="handlePageChange($event)"
        responsiveLayout="scroll" [resizableColumns]="true" columnResizeMode="expand"  [sortField]="sortfield" [sortOrder]="sortorder">

        <!-- search -->
        <ng-template pTemplate="caption">
          <div class="grid table-header ">
            <div class="col-12 md:col-10 sm:col-12 lg:col-10">
              <span class=" p-input-icon-lft">
                <i icon="pi pi-search"></i>
                <input class="form-control" pInputText type="text" id="tablesearch"
                  (input)="dt.filterGlobal($any($event.target).value , 'contains')" placeholder="Search in User"
                  class="tablesearch" pTooltip="Enter Search Criteria" tooltipPosition="top" />
              </span>
            </div>
            <div class="col-12 lg:col-2 md:col-2 sm:col-12">
              <div class="flex justify-content-end gap-3">
                <!-- pending functionality -->
                <div *ngIf="userRole  == 0" class="iconexcel" pTooltip="Download Excel Data" tooltipPosition="bottom"
                  style="cursor: pointer;" (click)="showDialog('super')"></div>

                <div *ngIf="userRole!== 0"class="iconexcel" pTooltip="Download Data" tooltipPosition="bottom" style="cursor: pointer;"
                  (click)="showDialog('excelDownload')"></div>
                <div *ngIf="!issuperadmin" class="iconexcellock" pTooltip="Download Lock Data" tooltipPosition="bottom" style="cursor: pointer;"
                  (click)="showDialog('lockData')"></div>
            <div *ngIf="isSupportAdmin === 'Y' || (orgId === 1 && userRole  === 1)" class="iconexcelusermapped" pTooltip="User Mapped Data Download" tooltipPosition="bottom" style="cursor: pointer;"
                  (click)="showDialog('mappedDataDownload')"></div>
              </div>
            </div>

          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 5px !important;" class="tableaction">Action</th>
            <ng-container *ngFor="let col of _selectedColumns">
              <th [pSortableColumn]="col.field" *ngIf="col.isChecked" pResizableColumn>
                {{col.header}}<p-sortIcon [field]="col.field"></p-sortIcon>
                <p-columnFilter type="text" *ngIf="col.filter" [field]="col.field" display="menu"></p-columnFilter>

              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
          <tr>
            <td style="width: 5px !important;">
              <div style="display: flex; gap: 0px;">
                <span class="actionItm" pTooltip="Modify" tooltipPosition="left"> <i class="fa fa-edit"
                    (click)="show('Modify User',data)"></i>
                </span>
              </div>
            </td>
            <ng-container *ngFor="let col of _selectedColumns">
              <td *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class">
                <span *ngIf="col.field!=='activeflag'" [pTooltip]="data[col.field]" [tooltipPosition]="left">{{data[col.field]}}
                 
                </span>
                  <span *ngIf="col.field!=='activeflag' && col.field=='username' && data.threemonthlock=='Y' "> <i class="fa fa-lock errormessage" [pTooltip]="threelocktooltip" tooltipPosition="left"></i> </span>
                  <span *ngIf="col.field!=='activeflag' && col.field=='username' && data.lockflag=='L' && data.threemonthlock=='N'  "> <i class="fa fa-lock" style="color: blue;" [pTooltip]="locktooltip" tooltipPosition="left"></i> </span>

<!-- <span *ngIf="col.field=='role' && col.field!=='activeflag'" pTooltip="Multiple role"tooltipPosition="left">Multiple role -->
                  <span class="actionItm" *ngIf="col.field=='rolename'"> <i class="fa fa-info-circle" (click)="show('Mapped Module',data)"></i>
                  </span>
                <!-- </span> -->
                

                <span *ngIf="col.field=='activeflag'">
                  <i *ngIf="data[col.field]=== 'Y'" pTooltip="Active" tooltipPosition="left" class="fa fa-flag"
                    aria-hidden="true" style="color: green;"></i>
                  <i *ngIf="data[col.field]!== 'Y'" pTooltip="Inactive" tooltipPosition="left" class="fa fa-flag"
                    aria-hidden="true" style="color: red;"></i>
                </span>
              </td>
            </ng-container>
          </tr>
        </ng-template>
          <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="_selectedColumns.length + 1"  class="datanotfound">
                No data available
            </td>
        </tr>
    </ng-template>
      </p-table>
    </div>
  
    <!-- </div> -->
  </p-tabView>
</p-card>


<!-- download excel formate for bulkupload -->
<p-dialog header="Download Excel Format For User Creation" [(visible)]="downloadformate" [modal]="true" [baseZIndex]="10000"
  [draggable]="true" [resizable]="false" position="center" [style]="{width: '70%', height: '30%'}">
  <div class="dialog-content-min-excel" style=" text-align: center !important;">
    <div class="card">
      <p>{{templatedownloadtext}}</p>
    </div>
  </div>
  <div class="custom-dialog-footer">
    <p-button class="m-1 w-full" label="Close" styleClass="customeclose" (click)="downloadformate=false"></p-button>
    <p-button class="m-1 w-full" label="Download" styleClass="customesave" (click)="excelUploadFormat()"></p-button>
  </div>
</p-dialog>